import DashView from './components/Dash.vue'
import LoginView from './components/Login.vue'
import SignupView from './components/Signup.vue'
import NotFoundView from './components/404.vue'
import DashboardView from './components/views/Dashboard.vue'
import EditIDCard from './components/views/EditIDCard'

// routes for conference.visity.io
import Registrations from './components/views/Registrations.vue'
import Checkpoints from './components/views/Checkpoints.vue'
import AccessLogs from './components/views/AccessLogs.vue'



// Routes
const routes = [
  {
    path: '/signup',
    component: SignupView
  },
  {
    path: '/login',
    component: LoginView
  },
  { 
    path: '/edit-id-card',
    alias: '',
    component: EditIDCard,
    name: 'Edit ID Card',
    meta: {description: ''}
  },
  {
    path: '/',
    component: DashView,
    children: [
      {
        path: 'registrations',
        alias: '',
        component: Registrations,
        name: 'Registrations',
        meta: {description: ''}
      },
      // { 
      //   path: 'edit-id-card',
      //   alias: '',
      //   component: EditIDCard,
      //   name: 'Edit ID Card',
      //   meta: {description: ''}
      // },
      {
        path: 'checkpoints',
        alias: '',
        component: Checkpoints,
        name: 'QR Code Scanner',
        meta: {description: ''}
      },
      {
        path: 'history',
        alias: '',
        component: AccessLogs,
        name: 'Scanner History',
        meta: {description: ''}
      },
      {
        path: 'dashboard',
        alias: '',
        component: DashboardView,
        name: 'Dashboard',
        meta: {description: ''}
      }
    ]
  }, {
    // not found handler
    path: '*',
    component: NotFoundView
  }
]

export default routes



// WEBPACK FOOTER //
// ./src/routes.js